import React from 'react';
import { ScoreTierEntity } from 'pages/LenderWaterfall/ScorecardBuilder/types';
import { Listing, useListing } from 'components/shared/TableListing';
import { FinanceProgramTiersTableContext } from 'modules/financeProgram/types';
import { financeProgramTiersColumns } from 'modules/financeProgram/constants';
import { getInitialFinanceProgramTiersTableData } from 'modules/financeProgram/lib';
import { FinanceProgramTierForm } from 'modules/financeProgram/schema';
import { Nullable } from 'global';

interface Props {
  isReadOnly: boolean;
  scoreTiers: ScoreTierEntity[];
  financeProgramTiers?: Nullable<FinanceProgramTierForm[]>;
  onListingChange: (value: FinanceProgramTierForm[]) => void;
}

export const FinanceProgramTiers = ({ isReadOnly, scoreTiers, financeProgramTiers, onListingChange }: Props) => {
  const { form, columns, tableData } = useListing<FinanceProgramTierForm, FinanceProgramTiersTableContext>(
    {
      headerColumns: financeProgramTiersColumns,
      bodyFields: financeProgramTiers || getInitialFinanceProgramTiersTableData(scoreTiers),
    },
    { onSubscribe: onListingChange, shouldUnregister: false, disabled: isReadOnly }
  );

  return (
    <Listing<FinanceProgramTierForm, FinanceProgramTiersTableContext>
      columns={columns}
      tableData={tableData}
      injectContext={{ form }}
    />
  );
};
